__webpack_require__.p = "/dist/gk-jss-app/";